import '../css/app.pcss';
import '../../node_modules/flickity/dist/flickity.css';
import '../../node_modules/fullpage.js/dist/fullpage.css';

import smoothscroll from 'smoothscroll-polyfill';
smoothscroll.polyfill();

require('fslightbox');


/* ==========================================================================
Smooth Scroll Anchor Tags
========================================================================== */
document.querySelectorAll('a.mobile-anchor').forEach(trigger => {
    trigger.onclick = function(e) {
        e.preventDefault();
        let hash = this.getAttribute('href');
        let target = document.querySelector('[data-anchor="'+hash.replace('#', '')+'"]');
        let headerOffset = 0;
        let elementPosition = target.offsetTop;
        let offsetPosition = elementPosition - headerOffset;

        window.scrollTo({
            top: offsetPosition,
            behavior: "smooth"
        });
    };
});

/* ==========================================================================
Video Placeholder
========================================================================== */
let videoController = document.querySelectorAll('.video-controller');
let videoPlaylist = document.querySelectorAll('.video-playlist');
let player;

if(videoController.length > 0){

    // Load API
    let tag = document.createElement("script");
        tag.src = "https://www.youtube.com/iframe_api";

    let firstScriptTag = document.getElementsByTagName("script")[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

    videoController.forEach( controller => {
        let placeholder     = controller.querySelectorAll('.video-placeholder');
        let video_iframe    = controller.querySelectorAll('iframe');
        let play_btn = placeholder[0].querySelectorAll('button');

        if(play_btn){
            play_btn[0].onclick = function(e){
                e.preventDefault();
                placeholder[0].classList.add('pointer-events-none', 'invisible');

                let timestamp = (this.dataset.timestamp) ? this.dataset.timestamp : 0;
                onYouTubeIframeAPIReady(this.dataset.id, timestamp);
            }
        }
    });

    if(videoPlaylist.length > 0){

        let placeholder = videoController[0].querySelectorAll('.video-placeholder');

        videoPlaylist[0].querySelectorAll('button').forEach( button => {
            button.onclick = function(e){
                e.preventDefault();

                // Stop and destroy old instances of currently playing videos.
                if(player){
                    player.stopVideo();
                    player.destroy();
                }

                // Remove cur class
                videoPlaylist[0].querySelectorAll('button').forEach( other_button => {
                    other_button.classList.remove('cur');
                });

                // Add cur class back to current video
                this.classList.add('cur');

                // Hide the placeholder
                placeholder[0].classList.add('pointer-events-none', 'invisible');

                // Play the video
                document.querySelectorAll('.current-video-title')[0].firstChild.nodeValue = this.dataset.title;
                document.querySelectorAll('.current-video-counter-cur')[0].firstChild.nodeValue = this.dataset.index;

                let timestamp = (this.dataset.timestamp) ? this.dataset.timestamp : 0;
                onYouTubeIframeAPIReady(this.dataset.id, timestamp);
            }
        });
    }
}


function autoplayNextVideo( event ){
    let current_btn = videoPlaylist[0].querySelectorAll('button.cur');
    let nextItem = current_btn[0].closest('li').nextElementSibling;

    if(nextItem){
        nextItem.querySelectorAll('button')[0].click()
    }
    else{
        console.log('last video, no more.');
    }
}

function onYouTubeIframeAPIReady( id,timestamp ) {
    console.log(id, timestamp);

    player = new YT.Player("player", {
        height: "550",
        width: "854",
        videoId: id,
        playerVars: {
            controls: 1,
            rel: 0,
            modestbranding: 1,
            start: timestamp,
        },
        events: {
            onReady: onPlayerReady,
            onStateChange: onPlayerStateChange
        }
    });
}

function onPlayerReady(event) {
    event.target.playVideo();
}

function onPlayerStateChange(event){
    let playerStatus = event.data;

    if (playerStatus == -1) {
        // unstarted = gray
    }
    else if (playerStatus == 0) {
        autoplayNextVideo( event ); // ended = yellow
    }
    else if (playerStatus == 1) {
        // playing = green
    }
    else if (playerStatus == 2) {
        // paused = red
    }
    else if (playerStatus == 3) {
        // buffering = purple
    }
    else if (playerStatus == 5) {
        // video cued = orange
    }
}

/* ==========================================================================
========================================================================== */


// Accept HMR as per: https://webpack.js.org/api/hot-module-replacement#accept
if (module.hot) {
    module.hot.accept();
}
